import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { CoreApiConfiguration } from '../coreApiConfiguration';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
@Injectable()
export class NameService extends ServiceBase {

    private actionUrl: string;
    private _url: string;
    constructor(private _http: HttpClient, private _configuration: CoreApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._url = this.actionUrl + _configuration.name.url;
    }

    public get = (name: string): Observable<string> => {
        return this._http.get<any>(this._url + '?name=' + name);
    }

    public getBySearch = (name: string, foreignName: string, isActive: number, fromDate: Date, toDate: Date, pageIndex: number, rowNo: number): Observable<any> => {
        return this._http.get<any[]>(this._url + `/BySearch?name=${name ? name : ''}&foreignName=${foreignName ? foreignName : ''}&isActive=${(isActive == undefined || isActive == -1) ? null : Boolean(isActive)}&fromDate=${fromDate?.toISOString() || ''}&toDate=${toDate?.toISOString() || ''}&pageIndex=${pageIndex}&rowNo=${rowNo}`);
    }

    public post = (name: any): Observable<string> => {
        return this._http.post<any>(this._url, name);
    }

    public update = (name: any): Observable<string> => {
        return this._http.put<any>(this._url, name);
    }
}